import React, { Component } from 'react';
import { Step, Steps, WithWizard, Wizard } from 'react-albus';
import SelectReportType from './Steps/SelectReportType';
import FilterRecords from './Steps/FilterRecords';
import SelectReportFormat from './Steps/SelectReportFormat';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import './GenerateReportWizard.css';
import { connect } from 'react-redux';
import { reportActions } from '../../../Reducks/Reports';
import { actions as virtualEventActions } from '../../../Reducks/VirtualEvents';
import { Button } from 'reactstrap';
import WizardBreadCrumbComponent from '../../../Components/WizardBreadCrumb/WizardBreadCrumbComponent';
import { getReportTypeInfo, validateSelection, WizardStepID } from './GenerateReportWizardUtils';
import { DESKTOP_DEVICE, MOBILE_DEVICE, ReportType } from '../../../Utils/Constants';
import { trackSendEmail } from '../../../Telemetry/Mixpanel/Features/analyticsTracker';

export class GenerateReportWizard extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    isBig: PropTypes.bool.isRequired,
    reduced_webinars: PropTypes.object,
    reduced_recordings: PropTypes.object,
    reduced_sessions: PropTypes.object,
    reduced_user: PropTypes.object,
    submitReportGenerationJob: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      reportType: null,
      reportFormatType: null
    };
  }

  render() {
    const { t } = this.context;
    const { reportType, reportFormatType } = this.state;
    const customMargin = {
      margin: '0px 12px'
    };
    const {
      reduced_webinars,
      reduced_sessions,
      reduced_recordings,
      reduced_virtual_events,
      isBig,
      reduced_user
    } = this.props;
    const numberOfSelectedSessions =
      this.props.uniqueTableId === 'sesssionsTableInOverview'
        ? reduced_sessions.sessions.filteredSelectedSessionKeys.length
        : reduced_sessions.filterReportSessions.filteredSelectedSessionKeys.length;
    const numberOfSelectedWebinars = reduced_webinars.webinars.filteredSelectedWebinarKeys.length;
    const numberOfSelectedVirtualEvents = reduced_virtual_events.virtualEvents.filteredSelectedVirtualEventKeys.length;
    const selectedVirtualEventTitle =
      numberOfSelectedVirtualEvents > 0
        ? reduced_virtual_events.virtualEvents.byKey[
            reduced_virtual_events.virtualEvents.filteredSelectedVirtualEventKeys[0]
          ].title
        : '';

    const numberOfSelectedRecordings =
      this.props.uniqueTableId === 'recordingTableInOverview'
        ? reduced_recordings.recordings.filteredSelectedRecordingKeys.length
        : reduced_recordings.filterRecordings.filteredSelectedRecordingKeys.length;
    const warningMessageComponent = this.validator().error !== null && <WarningMessage {...this.validator()} />;

    return (
      <Modal
        isOpen={this.props.isOpen}
        shouldCloseOnOverlayClick={true}
        className="generateReportWizardModal"
        ariaHideApp={false}
        onRequestClose={this.props.toggle}
        overlayClassName="generateReportWizardModalOverlay">
        <Wizard>
          <div className="heading">
            <div className="d-flex justify-content-between align-items-center title">
              <div>{t('report.generateReportLower')}</div>
              <i className="togo-icon togo-icon-closes close closeButton" onClick={this.props.toggle} />
            </div>
            <WizardBreadCrumb reportType={reportType} />
          </div>

          <div className="body">
            <Steps>
              <Step
                id={WizardStepID.SELECT_REPORT_TYPE}
                render={() => (
                  <SelectReportType
                    isVirtualEventsEnabled={
                      reduced_user.entitlements.isVirtualEventsEnabled &&
                      reduced_user.entitlements.isVirtualEventsEntitled &&
                      reduced_user.entitlements.isVirtualEventsProvisioned
                    }
                    reportTypeSelected={this.state.reportType}
                    setReportType={this.setReportType}
                    isBig={this.props.isBig}
                  />
                )}
              />
              <Step
                id={WizardStepID.FILTER_RECORDS}
                render={({ push }) => (
                  <FilterRecords
                    reportType={this.state.reportType}
                    warningMessage={warningMessageComponent}
                    navigateToReportTypeRow={
                      <NavigateToReportTypeRow
                        reportType={this.state.reportType}
                        navigate={() => push(WizardStepID.SELECT_REPORT_TYPE)}
                        isBig={this.props.isBig}
                      />
                    }
                    isBig={this.props.isBig}
                  />
                )}
              />
              <Step
                id={WizardStepID.SELECT_REPORT_FORMAT}
                render={({ push }) => (
                  <SelectReportFormat
                    reportType={this.state.reportType}
                    reportFormatType={this.state.reportFormatType}
                    setReportFormatType={this.setReportFormatType}
                    navigateToReportTypeRow={
                      <NavigateToReportTypeRow
                        reportType={this.state.reportType}
                        navigate={() => push(WizardStepID.SELECT_REPORT_TYPE)}
                        isBig={this.props.isBig}
                      />
                    }
                    navigateToFilterRecordsRow={
                      <NavigateToFilterRecordsRow
                        navigate={() => push(WizardStepID.FILTER_RECORDS)}
                        reportType={reportType}
                        numberOfSelectedSessions={numberOfSelectedSessions}
                        numberOfSelectedWebinars={numberOfSelectedWebinars}
                        numberOfSelectedRecordings={numberOfSelectedRecordings}
                        selectedVirtualEventTitle={selectedVirtualEventTitle}
                        numberOfSelectedVirtualEvents={numberOfSelectedVirtualEvents}
                      />
                    }
                  />
                )}
              />
            </Steps>
          </div>

          <WithWizard
            render={({ step, push }) => {
              const downloadReportButtonComponent = (
                <Button
                  id="downloadReport"
                  color="primary"
                  className={'button-dark-mode-override'}
                  disabled={
                    step.id !== WizardStepID.SELECT_REPORT_FORMAT ||
                    reportType === null ||
                    reportFormatType === null ||
                    this.validator().error !== null
                  }
                  onClick={() => this.generateReport(!isBig)}>
                  {isBig ? t('buttons.download') : t('report.emailReport')}
                </Button>
              );

              const emailReportButtonComponent = (
                <Button
                  id="downloadReport"
                  color="primary"
                  style={customMargin}
                  className={'button-dark-mode-override'}
                  disabled={
                    step.id !== WizardStepID.SELECT_REPORT_FORMAT ||
                    reportType === null ||
                    reportFormatType === null ||
                    this.validator().error !== null
                  }
                  onClick={() => this.generateReport(isBig, DESKTOP_DEVICE)}>
                  {t('report.emailReport')}
                </Button>
              );

              const navigateButtonComponent = (
                <NavigateButton
                  stepId={step.id}
                  push={push}
                  disabled={this.validator().error !== null}
                  reportType={reportType}
                  isBig={isBig}
                  reportFormatType={reportFormatType}
                />
              );
              const cancelButtonComponent = (
                <Button color="link" onClick={this.props.toggle}>
                  {t('buttons.cancel')}
                </Button>
              );
              const proceedNavigateButton = (
                <NavigateButton
                  stepId={step.id}
                  push={push}
                  disabled={this.validator().error !== null}
                  reportType={reportType}
                  isBig={isBig}
                  reportFormatType={reportFormatType}
                />
              );
              return (
                <div className="submission">
                  {isBig ? (
                    <React.Fragment>
                      <div>
                        {warningMessageComponent && step.id === WizardStepID.FILTER_RECORDS
                          ? warningMessageComponent
                          : reportType === ReportType.VIRTUAL_EVENT_EXECUTIVE_SUMMARY_REPORT ||
                            reportType === ReportType.VIRTUAL_EVENT_REGISTRATION_REPORT
                          ? null
                          : navigateButtonComponent}
                      </div>
                      <div className="submissionButtons">
                        {cancelButtonComponent}
                        {(reportType === ReportType.VIRTUAL_EVENT_EXECUTIVE_SUMMARY_REPORT ||
                          reportType === ReportType.VIRTUAL_EVENT_REGISTRATION_REPORT) &&
                          proceedNavigateButton}
                        {reportType === ReportType.VIRTUAL_EVENT_EXECUTIVE_SUMMARY_REPORT ||
                        reportType === ReportType.VIRTUAL_EVENT_REGISTRATION_REPORT
                          ? step.id === WizardStepID.SELECT_REPORT_FORMAT
                            ? emailReportButtonComponent
                            : null
                          : emailReportButtonComponent}
                        {reportType === ReportType.VIRTUAL_EVENT_EXECUTIVE_SUMMARY_REPORT ||
                        reportType === ReportType.VIRTUAL_EVENT_REGISTRATION_REPORT
                          ? step.id === WizardStepID.SELECT_REPORT_FORMAT && numberOfSelectedVirtualEvents === 1
                            ? downloadReportButtonComponent
                            : null
                          : downloadReportButtonComponent}
                      </div>
                    </React.Fragment>
                  ) : step.id === WizardStepID.SELECT_REPORT_FORMAT ? (
                    downloadReportButtonComponent
                  ) : (
                    navigateButtonComponent
                  )}
                </div>
              );
            }}
          />
        </Wizard>
      </Modal>
    );
  }

  setReportType = reportType => {
    if (
      reportType === ReportType.VIRTUAL_EVENT_EXECUTIVE_SUMMARY_REPORT ||
      reportType === ReportType.VIRTUAL_EVENT_REGISTRATION_REPORT
    ) {
      this.props.resetVirtualSelectedVirtualEventKeyAction();
    }
    this.setState({ reportType });
  };

  setReportFormatType = reportFormatType => this.setState({ reportFormatType });

  validator = () => {
    const { reportType } = this.state;
    const { reduced_webinars, reduced_sessions, reduced_recordings, reduced_virtual_events } = this.props;
    const {
      filteredSelectedTotalRegistrants,
      filteredSelectedTotalEngagementCount,
      filteredTotalRegistrants,
      filteredTotalEngagementCount
    } =
      this.props.uniqueTableId === 'sesssionsTableInOverview'
        ? reduced_sessions.stats
        : reduced_sessions.filterSessionStats;
    const numberOfSelectedSessions =
      this.props.uniqueTableId === 'sesssionsTableInOverview'
        ? reduced_sessions.sessions.filteredSelectedSessionKeys.length
        : reduced_sessions.filterReportSessions.filteredSelectedSessionKeys.length;
    const numberOfSelectedWebinars = reduced_webinars.webinars.filteredSelectedWebinarKeys.length;
    const selectedVirtualEventTitle =
      reduced_virtual_events.virtualEvents.filteredSelectedVirtualEventKeys.length > 0
        ? reduced_virtual_events.virtualEvents.byKey[
            reduced_virtual_events.virtualEvents.filteredSelectedVirtualEventKeys[0]
          ].title
        : '';

    const numberOfSelectedRecordings =
      this.props.uniqueTableId === 'recordingTableInOverview'
        ? reduced_recordings.stats.filteredSelectedStandaloneTotalVideos
        : reduced_recordings.filterRecordingStats.filteredSelectedStandaloneTotalVideos;

    const combinedStats = {
      filteredSelectedTotalRegistrants,
      filteredSelectedTotalEngagementCount,
      filteredTotalRegistrants,
      filteredTotalEngagementCount,
      numberOfSelectedSessions,
      numberOfSelectedWebinars,
      numberOfSelectedRecordings,
      selectedVirtualEventTitle
    };
    return validateSelection(reportType, combinedStats);
  };

  generateReport = (sendEmail, device) => {
    const { reportType, reportFormatType } = this.state;
    const { user } = this.props.reduced_user;
    const {
      reduced_webinars,
      reduced_sessions,
      reduced_recordings,
      reduced_virtual_events,
      submitReportGenerationJob
    } = this.props;
    const sessionKeys =
      this.props.uniqueTableId === 'sesssionsTableInOverview'
        ? reduced_sessions.sessions.filteredSelectedSessionKeys
        : reduced_sessions.filterReportSessions.filteredSelectedSessionKeys;
    const webinarKeys = reduced_webinars.webinars.filteredSelectedWebinarKeys;
    const virtualEventKeys = reduced_virtual_events.virtualEvents.filteredSelectedVirtualEventKeys;

    const recordingKeys =
      this.props.uniqueTableId === 'recordingTableInOverview'
        ? reduced_recordings.recordings.filteredSelectedRecordingKeys
        : reduced_recordings.filterRecordings.filteredSelectedRecordingKeys;

    if (sendEmail) {
      device ? trackSendEmail(device) : trackSendEmail(MOBILE_DEVICE);
    }

    switch (reportType) {
      case ReportType.SESSIONS_ATTENDANCE_REPORT:
      case ReportType.SESSIONS_QANDA_FOLLOW_UP_REPORT:
      case ReportType.SESSIONS_OVERVIEW_REPORT:
      case ReportType.WEBINAR_ATTENDEE_REPORT:
      case ReportType.WEBINAR_QANDA_REPORT:
      case ReportType.WEBINAR_PERFORMANCE_REPORT:
      case ReportType.WEBINAR_SURVEY_REPORT:
        submitReportGenerationJob(reportType, reportFormatType, sessionKeys, user, sendEmail);
        break;
      case ReportType.WEBINAR_REGISTRATION_REPORT:
        submitReportGenerationJob(reportType, reportFormatType, webinarKeys, user, sendEmail);
        break;
      case ReportType.WEBINAR_RECORDING_REPORT:
        submitReportGenerationJob(reportType, reportFormatType, recordingKeys, user, sendEmail);
        break;
      case ReportType.VIRTUAL_EVENT_EXECUTIVE_SUMMARY_REPORT:
        submitReportGenerationJob(reportType, reportFormatType, virtualEventKeys, user, sendEmail);
        break;
      case ReportType.VIRTUAL_EVENT_REGISTRATION_REPORT:
        submitReportGenerationJob(reportType, reportFormatType, virtualEventKeys, user, sendEmail);
        break;
      default:
        return false;
    }
    this.props.toggle();
  };
}

export const WizardBreadCrumb = ({ reportType }, { t, wizard }) => {
  const { step } = wizard;
  let text = '';
  switch (reportType) {
    case ReportType.WEBINAR_REGISTRATION_REPORT:
      text = t('generateReport.wizard.breadCrumb.webinars');
      break;
    case ReportType.WEBINAR_RECORDING_REPORT:
      text = t('generateReport.wizard.breadCrumb.recordings');
      break;
    case ReportType.VIRTUAL_EVENT_EXECUTIVE_SUMMARY_REPORT:
      text = 'Virtual Events';
      break;
    case ReportType.VIRTUAL_EVENT_REGISTRATION_REPORT:
      text = 'Virtual Events';
      break;
    default:
      text = t('generateReport.wizard.breadCrumb.sessions');
  }

  const navigationSteps = [
    {
      id: WizardStepID.SELECT_REPORT_TYPE,
      iconClass: 'report-icon',
      title: t('generateReport.wizard.breadCrumb.report'),
      onClick: () => {
        wizard.push(WizardStepID.SELECT_REPORT_TYPE);
      }
    },
    {
      id: WizardStepID.FILTER_RECORDS,
      iconClass: 'sessions-icon',
      title: text,
      onClick: () => {
        wizard.push(WizardStepID.FILTER_RECORDS);
      }
    },
    {
      id: WizardStepID.SELECT_REPORT_FORMAT,
      iconClass: 'file-type-icon',
      title: t('generateReport.wizard.breadCrumb.fileType')
    }
  ];
  return <WizardBreadCrumbComponent navigationSteps={navigationSteps} activeStep={step} />;
};
WizardBreadCrumb.contextTypes = {
  t: PropTypes.func.isRequired,
  wizard: PropTypes.any.isRequired
};
WizardBreadCrumb.propTypes = {
  reportType: PropTypes.string
};

export const NavigateToReportTypeRow = ({ reportType, isBig, navigate }, { t }) => {
  return (
    <div className="navigationRow">
      <div className="reportTitle">
        {isBig && <div className={`${getReportTypeInfo(reportType).iconClass}`} />}
        <div className="title">{getReportTypeInfo(reportType).title}</div>
      </div>
      <div className="textLowerCase">
        <Button color="link" onClick={navigate}>
          {reportType === ReportType.VIRTUAL_EVENT_EXECUTIVE_SUMMARY_REPORT ||
          reportType === ReportType.VIRTUAL_EVENT_REGISTRATION_REPORT
            ? t('generateReport.wizard.editSelection')
            : t('generateReport.wizard.editReportSelection')}
        </Button>
      </div>
    </div>
  );
};
NavigateToReportTypeRow.contextTypes = {
  t: PropTypes.func.isRequired
};
NavigateToReportTypeRow.propTypes = {
  reportType: PropTypes.string.isRequired,
  isBig: PropTypes.bool.isRequired,
  navigate: PropTypes.func
};

export const NavigateToFilterRecordsRow = (
  {
    reportType,
    numberOfSelectedSessions,
    numberOfSelectedWebinars,
    numberOfSelectedRecordings,
    numberOfSelectedVirtualEvents,
    selectedVirtualEventTitle,
    navigate
  },
  { t }
) => {
  let text = null;
  let title = null;
  switch (reportType) {
    case ReportType.SESSIONS_ATTENDANCE_REPORT:
    case ReportType.SESSIONS_QANDA_FOLLOW_UP_REPORT:
    case ReportType.SESSIONS_OVERVIEW_REPORT:
    case ReportType.WEBINAR_ATTENDEE_REPORT:
    case ReportType.WEBINAR_QANDA_REPORT:
    case ReportType.WEBINAR_PERFORMANCE_REPORT:
    case ReportType.WEBINAR_SURVEY_REPORT:
      text = t('generateReport.wizard.nSessionsSelected', { count: numberOfSelectedSessions });
      title = t('generateReport.wizard.editSelectedSessions');
      break;
    case ReportType.WEBINAR_REGISTRATION_REPORT:
      text = t('generateReport.wizard.nWebinarsSelected', { count: numberOfSelectedWebinars });
      title = t('generateReport.wizard.editSelectedWebinars');
      break;
    case ReportType.WEBINAR_RECORDING_REPORT:
      text = t('generateReport.wizard.nRecordingsSelected', { count: numberOfSelectedRecordings });
      title = t('generateReport.wizard.editSelectedRecordings');
      break;
    case ReportType.VIRTUAL_EVENT_EXECUTIVE_SUMMARY_REPORT:
      text = t(
        numberOfSelectedVirtualEvents > 1
          ? 'generateReport.wizard.virtualEventCountSelected'
          : 'generateReport.wizard.virtualEventTitleSelected',
        { count: numberOfSelectedVirtualEvents > 1 ? numberOfSelectedVirtualEvents : selectedVirtualEventTitle }
      );
      title = t('generateReport.wizard.editSelectedVirtualEvents');
      break;
    case ReportType.VIRTUAL_EVENT_REGISTRATION_REPORT:
      text = t(
        numberOfSelectedVirtualEvents > 1
          ? 'generateReport.wizard.virtualEventCountSelected'
          : 'generateReport.wizard.virtualEventTitleSelected',
        { count: numberOfSelectedVirtualEvents > 1 ? numberOfSelectedVirtualEvents : selectedVirtualEventTitle }
      );
      title = t('generateReport.wizard.editSelectedVirtualEvents');
      break;
    default:
      return null;
  }

  return (
    <div className="navigationRow">
      <div>{text}</div>
      <div className="textLowerCase">
        <Button color="link" onClick={navigate}>
          {title}
        </Button>
      </div>
    </div>
  );
};
NavigateToFilterRecordsRow.contextTypes = {
  t: PropTypes.func.isRequired
};
NavigateToFilterRecordsRow.propTypes = {
  reportType: PropTypes.string,
  numberOfSelectedSessions: PropTypes.number.isRequired,
  numberOfSelectedWebinars: PropTypes.number.isRequired,
  numberOfSelectedRecordings: PropTypes.number.isRequired,
  selectedVirtualEventTitle: PropTypes.string.isRequired,
  numberOfSelectedVirtualEvents: PropTypes.number.isRequired,
  navigate: PropTypes.func.isRequired
};

export const NavigateButton = ({ reportType, isBig, disabled, stepId, push }, { t }) => {
  let text = null;
  switch (reportType) {
    case ReportType.SESSIONS_ATTENDANCE_REPORT:
    case ReportType.SESSIONS_QANDA_FOLLOW_UP_REPORT:
    case ReportType.SESSIONS_OVERVIEW_REPORT:
    case ReportType.WEBINAR_ATTENDEE_REPORT:
    case ReportType.WEBINAR_QANDA_REPORT:
    case ReportType.WEBINAR_PERFORMANCE_REPORT:
    case ReportType.WEBINAR_SURVEY_REPORT:
      text = t('generateReport.wizard.proceedSessions');
      break;
    case ReportType.WEBINAR_REGISTRATION_REPORT:
      text = t('generateReport.wizard.proceedWebinars');
      break;
    case ReportType.WEBINAR_RECORDING_REPORT:
      text = t('generateReport.wizard.proceedRecordings');
      break;
    case ReportType.VIRTUAL_EVENT_EXECUTIVE_SUMMARY_REPORT:
      text = t('generateReport.wizard.proceedVirtualEvents');
      break;
    case ReportType.VIRTUAL_EVENT_REGISTRATION_REPORT:
      text = t('generateReport.wizard.proceedVirtualEvents');
      break;
    default:
      text = t('generateReport.wizard.proceedSessions');
  }

  return (
    <React.Fragment>
      {stepId === WizardStepID.FILTER_RECORDS && (
        <Button color="primary" onClick={() => push(WizardStepID.SELECT_REPORT_FORMAT)} disabled={disabled}>
          {text}
        </Button>
      )}
      {!isBig && stepId === WizardStepID.SELECT_REPORT_TYPE && (
        <Button color="primary" onClick={() => push(WizardStepID.FILTER_RECORDS)} disabled={reportType === null}>
          {t('buttons.next')}
        </Button>
      )}
    </React.Fragment>
  );
};

NavigateButton.contextTypes = {
  t: PropTypes.func.isRequired
};
NavigateButton.propTypes = {
  reportType: PropTypes.string,
  isBig: PropTypes.bool,
  disabled: PropTypes.bool,
  stepId: PropTypes.string,
  push: PropTypes.func
};

export class WarningMessage extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };
  static propTypes = {
    error: PropTypes.string,
    subMessage: PropTypes.string,
    moreInfoTooltip: PropTypes.string
  };

  render() {
    const { error, subMessage } = this.props;

    const errorMessage = error ? <div> {error}</div> : null;
    const subMessageElement = subMessage ? <div className="moreInfo">{subMessage}</div> : null;

    return (
      <div className="warningMessage">
        {errorMessage}
        {subMessageElement}
      </div>
    );
  }
}

export default connect(
  state => ({
    reduced_webinars: state.reduced_webinars,
    reduced_recordings: state.reduced_recordings,
    reduced_sessions: state.reduced_sessions,
    reduced_virtual_events: state.reduced_virtual_events,
    reduced_user: state.reduced_user
  }),
  {
    submitReportGenerationJob: reportActions.submitReportGenerationJob,
    resetVirtualSelectedVirtualEventKeyAction: virtualEventActions.resetVirtualSelectedVirtualEventKeyAction
  }
)(GenerateReportWizard);



// WEBPACK FOOTER //
// ./src/GoToWebinar/GenerateReport/Wizard/GenerateReportWizard.js